function getValueByPath(obj: any, path: string): any {
  return path.split('.').reduce((acc, part) => acc?.[part], obj);
}

export function areRequiredFieldsFilled<T extends Record<string, any>>(
  data: T,
  requiredFields: string[],
): boolean {
  return requiredFields
    .map((field) => {
      return !!getValueByPath(data, field);
    })
    .every(Boolean);
}
